export enum Role {
    ROLE_ADMIN = 'ROLE_ADMIN',
    ROLE_EXEC = 'ROLE_EXEC',
    ROLE_OWNER = 'ROLE_OWNER',
    ROLE_USER = 'ROLE_USER',
    ROLE_TENANT = 'ROLE_TENANT',
    ROLE_GUEST = 'ROLE_GUEST',
    ROLE_SUPER = 'ROLE_SUPER'
}